import { WEB_CALLING_ENABLED, WEB_CALLING_ENABLED_ORG_IDS } from 'src/constants/misc';
import { paths } from 'src/routes/paths';

/**
 * Whether the organization is listed in WEB_CALLING_ENABLED_ORG_IDS, and so shows Assigned Tasks
 * in the sidebar. Always false while the WEB_CALLING_ENABLED master switch is off. The id is
 * coerced because the org context and localStorage do not agree on a type for it. An unresolved
 * (`undefined`) or failed (`null`) selection, and a superadmin's "All Organizations" (`0`), are
 * never listed — the entry simply stays hidden until an org is known.
 */
export const isWebCallingEnabled = (organizationId) =>
  WEB_CALLING_ENABLED &&
  organizationId != null &&
  WEB_CALLING_ENABLED_ORG_IDS.includes(Number(organizationId));

/**
 * Whether Assigned Tasks is locked for the organization: it is a real, selected organization and
 * it is not listed. Unlike isWebCallingEnabled this is false while nothing is known — an
 * unresolved (`undefined`) or failed (`null`) selection, or "All Organizations" (`0`) — so the
 * lock never flashes over the page while the org context resolves.
 */
export const isWebCallingLocked = (organizationId) =>
  Boolean(Number(organizationId)) && !isWebCallingEnabled(organizationId);

/** True for the Assigned Tasks list and anything under it. */
export const isAssignedTasksPath = (path) =>
  typeof path === 'string' &&
  (path === paths.assignedTasks.root || path.startsWith(`${paths.assignedTasks.root}/`));
